import { render, staticRenderFns } from "./ResourceDivision.vue?vue&type=template&id=194f5d4a&scoped=true&"
import script from "./ResourceDivision.vue?vue&type=script&lang=js&"
export * from "./ResourceDivision.vue?vue&type=script&lang=js&"
import style0 from "./ResourceDivision.vue?vue&type=style&index=0&id=194f5d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194f5d4a",
  null
  
)

export default component.exports